
const TechnologyCard = ({ img, heading }) => {
  return (
    <div className='flex w-[320px] lg:w-[430px] 800:w-[415px] md:w-[415px] max-w-[460px] flex-col items-center justify-center bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[15px]  p-[3px] '>
      <div className='flex flex-col items-center justify-center gap-[16px] bg-black rounded-[15px] py-[24px] px-[15px] w-full h-full'>
        <img src={img} alt="Technology Icon" className='md:h-[60px] xs:h-[40px]' />
        <p className='font-faustina font-regular lg:text-[32px] md:text-[22px] xs:text-[clamp(18px,3.2vw,22px)] text-white w-full text-center'>{heading}</p>
      </div>
    </div>
  )
}

export default TechnologyCard